import { z } from 'zod'

const mobilePhoneSchema = z.object({
  countryCode: z.string().min(1),
  number: z.string().min(1)
})

export const profileSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  companyName: z.string().min(1),
  jobTitle: z.string().min(1),
  phone: mobilePhoneSchema,
  locationCount: z.string().min(1),
  employeeCount: z.string().min(1),
  industry: z.string().min(1),
  isFranchise: z.boolean(),
  country: z.string().min(1)
})

export type Profile = z.infer<typeof profileSchema>

export type PostOauthPasswordGrantPayload = {
  grant_type: 'password'
  email: string
  password: string
  client_id: string
  client_secret: string
}

export type PostOauthRefreshTokenPayload = {
  grant_type: 'refresh_token'
  client_id: string
  client_secret: string
}

export type DraftAccountFormData = {
  profile?: Profile | {}
}

export type PostOauthResponse = {
  token_type: 'Bearer'
  expires_at: string
  expires_in: number
  user_id: number
  info: {
    accounts: {
      slug: string
      id: number
      membership_id: number
    }[]
    email: string
    account_ids: number[]
    membership_ids: number[]
    super_user: boolean
    is_account_creation_in_progress?: boolean
  }
}
